import styled from "@emotion/styled"


export const Navbar = styled.nav`
  position: fixed;
  display: flex;
  justify-content: space-around;
  background-color: white;
  max-width: 440px;
  min-width: 320px;
  padding-top: 5px;
  width: 100%;
  height: 70px;
  margin: auto;
  bottom: 0;
  border-top: 1px solid gray;
`